<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="d-flex smart-item">
        <v-layout text-right wrap>
          <v-flex pt-2 pb-2 pa-2>
            <v-layout wrap>
              <v-flex xl3 lg3 md3 xs12 class="smart-item-title">
                <span class="display-24">{{ text }}</span>
                <span v-if="required" class="red--text display-14 d-block">
                  * {{ t(`titles.requiredField`) }}
                </span>
              </v-flex>
              <v-divider
                vertical
                class="ml-1"
                v-show="$vuetify.breakpoint.smAndUp"
              />
              <v-flex
                class="display-18 smart-item-fields py-1"
                align-self-center
              >
                {{ radioGroup.NameInHebrew }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-1 pa-0">
      <v-flex xs12>
        <v-layout wrap justify-start mt-2>
          <v-flex>
            <v-radio-group v-model="radioGroup" row class="mt-0">
              <v-radio
                v-for="(item, i) in items"
                :key="i"
                :label="item.NameInHebrew"
                :value="item"
                class="alert-item display-24 mr-1 ml-8"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { filter } from 'lodash';



export default {

  props: {
    items: {
      type: Array,
      default: Array,
    },

    text: {
      type: String,
      default: '',
    },

    cautionMsg: {
      type: String,
      default: '',
    },

    showMsgIfLessThen: {
      type: Number,
    },

    required: {
      type: Boolean,
    },
  },

  data() {
    return {
      selections: [],
      radioGroup: {},
      selectionsCodes: [],
    };
  },

  watch: {
    radioGroup(newVal, oldVal) {
      this.$emit('selectionsUpdated', this.radioGroup);
    },
  },

  mounted() {
    this.radioGroup = filter(this.items , function(o) { return o.IsSelected; })[0] ;

  },
};
</script>

<style lang="scss" scoped>

.caution {
  color: red;
  align-self: flex-start;
}

@media only screen and (min-width: 960px) {
}

@media only screen and (min-width: 600px) {
.v-input--radio-group.v-input--radio-group--row .v-radio {
    display: flex;
    padding: 20px 10px;
    background-color: #f2f2f2;
    height:100px;
    width:340px
  }
.v-input--radio-group.v-input--radio-group--row .v-radio .v-label {

    font-size:24px
  }
}
</style>
